import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrentTenantService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/current-tenant.service';
import { GlobalElementsService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/global-elements.service';

@Component({
  standalone: false,
  selector: 'public-footer',
  template: `
    @if (prepend(); as prepend) {
      <div [innerHTML]="prepend"></div>
    }

    @if (globalElements(); as globalElements) {
      <footer
        [style.background]="globalElements.footer?.background ?? '#fff'"
        [style.color]="globalElements.footer?.textColor ?? '#000'"
        style="padding: 50px 0"
        class="d-flex fd-col jc-center ai-center"
      >
        <div class="footer-row d-flex jc-around ai-start fd-col--xs">
          <div class="links-list-container d-flex fd-col jc-start ai-stretch" style="flex: 0 1 40%">
            <div class="d-flex fd-col jc-start ai-start">
              @if (currentTenant().logoUrl; as logoUrl) {
                <logo [logoUrl]="logoUrl" logoTheme="white" style="height: 28px" />
              } @else {
                <div>{{ currentTenant().tenantName }}</div>
              }

              @if (globalElements.footer?.footerTagLine; as tagLine) {
                <h3 class="padding-title">{{ tagLine }}</h3>
              }

              <span
                >&copy; {{ copyYear }} -
                {{ globalElements.footer?.copyrightText ?? currentTenant().tenantName }}</span
              >

              <!-- <span>
                Powered by
                <b class="highlight">informally</b>
              </span> -->
            </div>
          </div>

          <div class="links-list-container d-flex fd-col jc-start ai-stretch" style="flex: 0 1 0">
            <h4>Sections</h4>
            <div class="d-flex fd-col jc-start ai-start">
              @for (link of featureLinks(); track link.route) {
                <a class="footer-link" [routerLink]="link.route">{{ link.displayName }}</a>
              }
            </div>
            <h4 class="padding-title">Account</h4>
            <div class="d-flex fd-col jc-start ai-start">
              @for (link of accountLinks; track link.route) {
                <a class="footer-link" [routerLink]="link.route">{{ link.title }}</a>
              }
            </div>
          </div>

          <div class="links-list-container d-flex fd-col jc-start ai-stretch" style="flex: 0 1 0">
            <h4>Info</h4>
            <div class="d-flex fd-col jc-start ai-start">
              @if (globalElements.helpLink; as helpLink) {
                <a [href]="helpLink" class="footer-link" target="_blank">Help</a>
              }

              <a routerLink="privacy-policy" class="footer-link">Privacy Policy</a>
              <a routerLink="terms-and-conditions" class="footer-link">Terms & Conditions</a>

              @if (globalElements.socialLinks?.length) {
                <div>
                  <h4 class="padding-title">Social</h4>
                  <div>
                    @for (socialLink of globalElements.socialLinks; track socialLink.link) {
                      <a
                        class="material-icons social-icons"
                        [href]="socialLink.link"
                        target="_blank"
                        >{{ socialLink.icon }}</a
                      >
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </footer>
    }
  `,
  styles: `
    .footer-row {
      width: 100%;
      max-width: 1300px;
    }

    .links-list-container {
      padding: 24px;
      min-width: 140px;

      @media (max-width: 600px) {
        padding: 0 24px;
        margin-top: 24px;
      }

      .social-icons {
        color: white;
        text-decoration: none;
      }
    }

    .footer-link {
      color: inherit;
      text-decoration: none;
      margin-bottom: 4px;
    }

    .padding-title {
      padding-top: 50px !important;

      @media (max-width: 600px) {
        padding-top: 24px !important;
      }
    }
  `,
})
export class FooterComponent {
  private readonly domSanitizer = inject(DomSanitizer);

  protected readonly globalElements = inject(GlobalElementsService).globalElements.asReadonly();

  protected readonly prepend = computed(() => {
    const value = this.globalElements()?.footer?.prepend;
    return value && this.domSanitizer.bypassSecurityTrustHtml(value);
  });

  protected readonly copyYear = new Date().getFullYear();

  protected readonly currentTenant = inject(CurrentTenantService).currentTenant;

  protected readonly featureLinks = input.required<{ route: string; displayName: string }[]>();

  protected readonly accountLinks: { title: string; route: string }[] = [
    { title: 'Log in', route: 'identity' },
    { title: 'Sign up', route: 'register' },
  ];
}
